









































































































































































import Vue from 'vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import { NavStepState } from '../lib/enums/navStepState';
import { ContactUploadStep } from '../lib/enums/contactUploadStep';
import {
  getContactUploadStates,
  getContinueToolTip
} from '../lib/contactUploadLogic';
import { isMobile, isTablet, isDesktop } from '../lib/utilities/breakpoints';
import {
  ContactUploadAction,
  ContactUploadRouterAction
} from '../lib/enums/contactUploadAction';

const NavigationSteps = [
  {
    name: 'Upload file',
    altText: '1',
    state: NavStepState.Enabled,
    step: ContactUploadStep.Start,
    onContinueRoute: '/contacts-upload/{action}'
  },
  {
    name: 'Confirm columns',
    altText: '2',
    state: NavStepState.Disabled,
    step: ContactUploadStep.ConfirmHeaders,
    onContinueRoute: '/contacts-upload/{uploadId}/confirm-headers'
  },
  {
    name: 'Map the data',
    altText: '3',
    state: NavStepState.Disabled,
    step: ContactUploadStep.MapData,
    onContinueRoute: '/contacts-upload/{uploadId}/map-data'
  },
  {
    name: 'Number lookups',
    altText: '4',
    state: NavStepState.Disabled,
    step: ContactUploadStep.NumberLookups,
    onContinueRoute: '/contacts-upload/{uploadId}/number-lookups'
  },
  {
    name: 'Import',
    altText: '5',
    class: 'pl-3',
    state: NavStepState.Disabled,
    step: ContactUploadStep.Import,
    onContinueRoute: '/contacts-upload/{uploadId}/import'
  }
];
export default Vue.extend({
  name: 'ContactsUploadNavigation',

  data() {
    return {
      ContactUploadStep,
      isContinueEnabled: true,
      continueTooltip: '',
      navAction: '',
      navStepData: [],
      onSaveCompleteTimeOut: 0,
      showCancelModal: false,
      highestStep: 0,
      showButtonSpinner: false,
      showOptOutConfirmationModal: false
    };
  },

  computed: {
    ...mapState('components/contact-upload-navigation', [
      'currentStep',
      'onContinueFunc',
      'isOverrideContinue'
    ]),
    ...mapState('contact-upload', { uploadId: 'id', action: 'action' }),
    ...mapState('contact-upload', { uploadState: state => state }),

    continueText() {
      return this.currentStep === ContactUploadStep.Import
        ? 'Start import'
        : 'Next';
    },
    currentStepName() {
      const currentStep = this.navStepData.find(
        ns => ns.step === this.currentStep
      );
      return currentStep ? currentStep.name : '';
    },

    isMobileView() {
      return isMobile(this.$vuetify);
    },

    isDesktopView() {
      return isDesktop(this.$vuetify);
    },

    isTabletView() {
      return isTablet(this.$vuetify);
    },

    isContinueActive() {
      if (!isDesktop(this.$vuetify)) {
        return true;
      }
      const stepStates = getContactUploadStates(
        this.currentStep,
        this.highestStep,
        this.uploadState
      );
      this.isContinueEnabled = this.getIsContinueEnabled(stepStates);
      return this.isContinueEnabled;
    },

    currentStepNumber() {
      return this.isOptOut && this.currentStep === ContactUploadStep.Import
        ? 4
        : this.currentStep;
    },

    isOptOut() {
      return this.action === ContactUploadAction.OptOut;
    },

    nextStep() {
      const nextStep = this.navStepData.find(
        ns =>
          ns.step ===
          this.currentStep +
            (this.currentStep === ContactUploadStep.MapData ? 2 : 1)
      );
      return nextStep;
    },

    showConfirmModal() {
      return (
        this.currentStep === ContactUploadStep.Import &&
        this.action === ContactUploadAction.OptOut
      );
    },

    previousStep() {
      const previousStep = this.navStepData.find(
        ns =>
          ns.step ===
          this.currentStep -
            (this.currentStep === ContactUploadStep.Import ? 2 : 1)
      );
      return previousStep;
    }
  },

  methods: {
    ...mapActions('contact-upload', ['clearUploadFields']),
    ...mapMutations('contact-upload', {
      setFileUploadError: 'setFileUploadError'
    }),

    onCancelModalAction(approve) {
      if (!approve) {
        this.showCancelModal = false;
        return;
      }

      this.$router.push('/contacts/subscribers');
    },

    handleContinueClick() {
      //Clear error
      this.setFileUploadError(null);
      if (!isDesktop(this.$vuetify) && this.hasErrors()) {
        return;
      }
      this.showConfirmModal
        ? this.showConfirmationModal()
        : this.onContinue(this.nextStep);
    },
    hasErrors() {
      const uploadError = getContinueToolTip(
        this.currentStep,
        this.uploadState
      );
      this.setFileUploadError(uploadError);

      if (uploadError) {
        return true;
      }
      return false;
    },
    getNavAction() {
      this.navAction =
        this.action === ContactUploadAction.OptOut
          ? ContactUploadRouterAction.OptOut
          : ContactUploadRouterAction.CreateAndUpdate;
    },
    getNavStepsData() {
      const navSteps = NavigationSteps;
      this.navStepData =
        this.action !== ContactUploadAction.OptOut
          ? navSteps
          : navSteps
              .filter(
                x =>
                  !(
                    x.step === ContactUploadStep.NumberLookups &&
                    this.action === ContactUploadAction.OptOut
                  )
              )
              .map((x, index) => {
                return {
                  name: x.name,
                  altText: (index + 1).toString(),
                  class: x.class,
                  state: x.state,
                  step: x.step,
                  onContinueRoute: x.onContinueRoute
                };
              });
    },

    showConfirmationModal() {
      this.showOptOutConfirmationModal = true;
    },
    onConfirmModalAction(approve) {
      if (!approve) {
        this.showOptOutConfirmationModal = false;
        return;
      }
      this.onContinue();
    },
    onSelectStep(name) {
      this.setFileUploadError(null);
      const selectedStep = this.navStepData.find(step => step.name == name);
      if (selectedStep.step != this.currentStep) {
        let path = selectedStep.onContinueRoute.replace(
          '{uploadId}',
          this.uploadId
        );
        if (selectedStep.step === ContactUploadStep.Start) {
          path = selectedStep.onContinueRoute.replace(
            '{action}',
            this.navAction
          );
        }

        this.$router.push({
          path
        });
      }
    },

    onChangeStep() {
      // Get continue button state, tooltip and states for each step in nav.
      this.highestStep = Math.max(this.currentStep, this.highestStep);

      const stepStates = getContactUploadStates(
        this.currentStep,
        this.highestStep,
        this.uploadState
      );
      this.isContinueEnabled = this.getIsContinueEnabled(stepStates);
      this.continueTooltip = getContinueToolTip(
        this.currentStep,
        this.uploadState
      );
      this.showButtonSpinner =
        !this.isContinueEnabled &&
        this.continueTooltip &&
        this.currentStep === ContactUploadStep.Import &&
        stepStates[this.currentStep] === NavStepState.InProgress;
      this.navStepData.forEach(navStep => {
        navStep.state = stepStates[navStep.step];
      });
    },

    // For all steps except the last step (Import), the continue button
    // is enabled if the step is complete. For the last step, clicking
    // the continue button is what changes the step to being complete,
    // so the button is enabled if the step is enabled. If the step is
    // complete, the continue button shouldn't be enabled because the
    // user shouldn't be able to redo a completed import.
    getIsContinueEnabled(stepStates: any): boolean {
      if (this.currentStep === ContactUploadStep.Import) {
        return stepStates[this.currentStep] === NavStepState.Enabled;
      }
      if (this.currentStep === ContactUploadStep.Start) {
        if (this.uploadState.isFileFormatError) return false;
      }

      return stepStates[this.currentStep] === NavStepState.Complete;
    },
    onPreviousStep() {
      const previousStep = this.previousStep;
      if (previousStep) {
        let path = previousStep.onContinueRoute.replace(
          '{uploadId}',
          this.uploadId
        );

        if (previousStep.step === ContactUploadStep.Start) {
          path = previousStep.onContinueRoute.replace(
            '{action}',
            this.navAction
          );
        }

        this.$router.push({
          path
        });
      }
      return;
    },

    onContinue(nextStep) {
      if (!nextStep) {
        nextStep = this.nextStep;
      }

      // nextStep is undefined for the last step
      let path = nextStep?.onContinueRoute.replace('{uploadId}', this.uploadId);

      if (this.isOverrideContinue) {
        // If page overrides nav continue behavior, it's up to that page to
        // handle routing when it receives this event.
        this.$nuxt.$emit('contact-upload-navigation-override-continue', {
          routeTo: path
        });
        return;
      }

      if (this.onContinueFunc) this.onContinueFunc();
      this.$router.push({
        path
      });
    }
  },

  watch: {
    currentStep: 'onChangeStep',

    uploadState: {
      handler: function () {
        this.onChangeStep();
        this.getNavAction();
      },
      deep: true
    }
  },
  created() {
    this.getNavAction();
    this.getNavStepsData();
    this.$nuxt.$on('contact-upload-remove-upload', () => {
      this.highestStep = 0;
    });
    this.$nuxt.$on('contact-upload-navigation-continue', () => {
      this.onContinue();
    });
  },
  beforeDestroy() {
    this.$nuxt.$off('contact-upload-remove-upload');
  }
});
